/**
 * Lightweight provider registry.
 *
 * This module is intentionally dependency-free so local scripts (provider CLI, harness
 * codegen, etc.) can read the provider list without importing the full API spec package
 * (which can pull in heavy or server-only runtime dependencies).
 */
export const ProviderKey = [
  'asana',
  'clickup',
  'github',
  'jira',
  'linear',
  'monday',
  'salesforce',
  'salesforce-sandbox',
  'trello',
  'base',
] as const;

export type Providers = (typeof ProviderKey)[number];
